import Vue from 'vue'
import Router from 'vue-router'
import Track from '@/utils/web-tracking';

// 基础页面
const Forgot = () => import('@/components/login/Forgot')
const Index = () => import('@/Index')
const HomeOutside = () => import('@/components/home/HomeOutside')
const HomeInside = () => import('@/components/home/HomeInside')
const RegisterResult = () => import('@/components/login/RegisterResult')

// 消息中心
const messageCenter = () => import('@/components/content/messageCenter/index')

// MyOrder 模块
const MyOrder = () => import('@/components/content/myOrder')
const OrderDetail = () => import('@/components/content/newDesign/OrderDetail')

const MyProfile = () => import('@/components/content/myProfile')

// Consumer Insights 模块
const ConsumerInsights = () => import('@/components/content/consumerInsights/ConsumerInsights')
const TrendMain = () => import('@/components/content/consumerInsights/trend/TrendMain')
const TrendMainChild = () => import('@/components/content/consumerInsights/trend/TrendMainChild')
const TrendDetail = () => import('@/components/content/consumerInsights/trend/TrendDetail')
const NewTrendDetail = () => import('@/components/content/consumerInsights/trend/NewTrendDetail')
const TrendList = () => import('@/components/content/consumerInsights/trend/TrendList')
const MarketOverview = () => import('@/components/content/consumerInsights/market/MarketOverview')
const TopRanking = () => import('@/components/content/consumerInsights/ranking/TopRanking')
const TopRankingClient = () => import('@/components/content/topRankingClient')
const Bevol = () => import('@/components/content/consumerInsights/ranking/bevol/Bevol')
const ConsumerProductsInsights = () => import('@/components/content/consumerInsights/ranking/bevol/ConsumerProductsInsights')
const ConsumerClaimsInsights = () => import('@/components/content/consumerInsights/ranking/bevol/ConsumerClaimsInsights')
const ConsumerBrandInsights = () => import('@/components/content/consumerInsights/ranking/bevol/ConsumerBrandInsights')
const OtherWebsite = () => import('@/components/content/consumerInsights/ranking/otherWebsite/OtherWebsite')
const SocialMedia = () => import('@/components/content/consumerInsights/ranking/socialmedia/SocialMedia')

// brand analytice 模块
// const BrandAnalytics = () => import('@/components/content/brandAnalytics/BrandAnalytics')
const BrandDetail = () => import('@/components/content/brandClient/detail')
const brandClient = () => import('@/components/content/brandClient/index')
// const newBrandDetail = () => import('@/components/content/brandClient/detail')

// ConsumerProducts 模块
const ConsumerProducts = () => import('@/components/content/consumerProducts/ConsumerProducts')
const ConsumerProductDetail = () => import('@/components/content/consumerProducts/consumerProductDetail/ConsumerProductDetail')
const ConsumerProductsList = () => import('@/components/content/consumerProductsClient')

// Concepts Collection 模块
const ConceptsCollection = () => import('@/components/content/conceptsCollection/ConceptsCollection')
const NewOldConcepts = () => import('@/components/content/conceptsCollection/NewOldConcepts')
const NewConcepts = () => import('@/components/content/conceptsCollection/NewConcepts')
const MoreConcepts = () => import('@/components/content/conceptsCollection/MoreConcepts')
const Euperlan = () => import('@/components/content/conceptsCollection/Euperlan')
const ConceptDetail = () => import('@/components/content/conceptsCollection/ConceptDetail')
const ConceptList = () => import('@/components/content/conceptsCollection/ConceptList')

// Formulation Design 模块
const FormulationDesign = () => import('@/components/content/formulationDesign/FormulationDesign')
const FormulationDesignIndex = () => import('@/components/content/formulationDesign/index')
const FormulationDetail = () => import('@/components/content/formulationDesign/formulationDetail/FormulationDetail')

// Ingredient Selection 模块
const IngredientSelection = () => import('@/components/content/ingredientSelection/IngredientSelection')
const IngredientDetail = () => import('@/components/content/ingredientSelection/ingredientDetail/IngredientDetail')
const TradeNameDetail = () => import('@/components/content/ingredientSelection/TradeNameDetail')
const IngredientList = () => import('@/components/content/ingredientClient')
const NewIngredientDetail = () => import('@/components/content/ingredientClient/detail')

// formulation new design 模块
const FormulationNewDesign = () => import('@/components/content/newDesign/FormulationNewDesign')
const FormulationPurchase = () => import('@/components/content/newDesign/FormulationPurchase')
const PurchasePurchase = () => import('@/components/content/newDesign/FormulationPurchasePurchase')
const Purchase = () => import('@/components/content/newDesign/Purchase')
const PurchaseDirectly = () => import('@/components/content/newDesign/PurchaseDirectly')

// boss 模块
const Boss = () => import('@/components/content/boss/Boss')
const AdvancedSearch = () => import('@/components/content/boss/AdvancedSearch')
const Search = () => import('@/components/content/boss/Search')

// My Comparison 模块
const Comparsion = () => import('@/components/content/comparsion/Comparsion')
const ProductComparison = () => import('@/components/content/consumerProducts/ProductComparison')
const BrandComparison = () => import('@/components/content/brandAnalytics/BrandComparison')
const FormulationComparison = () => import('@/components/content/formulationDesign/FormulationComparison')
const IngredientComparison = () => import('@/components/content/ingredientSelection/IngredientComparison')
const eventClient = () => import('@/components/content/eventClient')
const eventDetail = () => import('@/components/content/eventClient/detail')
const eventFormulationList = () => import('@/components/content/eventClient/formulationList')
const eventBasfProductList = () => import('@/components/content/eventClient/basfProductList')

// Introduction Video 模块
const introVideo = () => import('@/components/content/introVideo')
const videoList = () => import('@/components/content/introVideo/children/videoList')
const webinarList = () => import('@/components/content/introVideo/children/webinarList')
const care = () => import('@/components/content/introVideo/children/care')

// 全局搜索模块
const GeneralList = () => import('@/components/content/general/GeneralList')

// event 模块
const event = () => import('@/components/content/event')
const eventSpeaker = () => import('@/components/content/event/indexSpeaker')
const eventFormulationCategory = () => import('@/components/content/event/indexFormulationCategory')
const eventFormulation = () => import('@/components/content/event/indexFormulation')
const eventProductCategory = () => import('@/components/content/event/indexProductCategory')
// const eventSolution = () => import('@/components/content/event/indexSolution')
const eventConcept = () => import('@/components/content/event/indexConcept')
const eventProduct = () => import('@/components/content/event/indexProduct')
const eventTrend = () => import('@/components/content/event/indexTrend')

// 后台管理模块
const BASFProduct = () => import('@/components/content/BASFProduct')
const formulation = () => import('@/components/content/formulation')
const trend = () => import('@/components/content/trend')
const concept = () => import('@/components/content/concept')
const accounts = () => import('@/components/content/accounts')
const role = () => import('@/components/content/role/main')
const userGroup = () => import('@/components/content/userGroup')
const userBehavior = () => import('@/components/content/userBehavior')
const feedback = () => import('@/components/content/userBehavior/feedback')
const commentData = () => import('@/components/content/commentData')
const lifestyleSegment = () => import('@/components/content/lifestyleSegment')
const webinar = () => import('@/components/content/webinar')
const videoManagement = () => import('@/components/content/videoManagement')
const topManagement = () => import('@/components/content/topRanking')
const productList = () => import('@/components/content/topRanking/productList')
const productDetail = () => import('@/components/content/topRanking/productDetail')
const sourceDetail = () => import('@/components/content/topRanking/sourceDetail')
const formuCategory = () => import('@/components/content/formuCategory')
const formuProduct = () => import('@/components/content/formuProduct')
const message = () => import('@/components/content/message')
const activityLog = () => import('@/components/content/activityLog')
const whiteList = () => import('@/components/content/whiteList/main')
const blackList = () => import('@/components/content/blackList/index')
const requestList = () => import('@/components/content/orderList/main')
const inciManagement = () => import('@/components/content/inciManagement')
const push = () => import('@/components/content/pushManagement')
const deeplink = () => import('@/components/content/deeplinkManagement')

// General Management 模块
const aboutBASF = () => import('@/components/content/aboutBASF')
const appPictures = () => import('@/components/content/appPictures')
const topRankForOtherWebsite = () => import('@/components/content/topRankForOtherWebsite')
const topRrankingSourceIndex = () => import('@/components/content/topRankForOtherWebsite/topRrankingSourceIndex')
const otherWebsiteEditProduct = () => import('@/components/content/topRankForOtherWebsite/otherWebsiteEditProduct')
const announcement = () => import('@/components/content/announcement')
// 关系管理模块
const delivery = () => import('@/components/content/relationship/delivery')
const application = () => import('@/components/content/relationship/application')
const benefit = () => import('@/components/content/relationship/benefit')
const productGroup = () => import('@/components/content/relationship/productGroup')
const inciBasfMark = () => import('@/components/content/relationship/inciBasfMark')
const competitor = () => import('@/components/content/relationship/competitor/index')
const claim = () => import('@/components/content/relationship/claim')
const brandClaim = () => import('@/components/content/relationship/brandClaim')
const formfunction = () => import('@/components/content/relationship/function')
const dliteFunction = () => import('@/components/content/relationship/dliteFunction')
const basfFunction = () => import('@/components/content/relationship/basfFunction')
const bevolFunction = () => import('@/components/content/relationship/bevolFunction')
const commentKeywords = () => import('@/components/content/relationship/commentKeywords')
const newCommentKeywords = () => import('@/components/content/relationship/newCommentKeywords')

const coowner = () => import('@/components/content/coowner/index')
// const qrCode = () => import('@/components/content/qrCode/index')
const qrCode = () => import('@/components/content/qrCode/main')

// errorPage
const notFound = () => import('@/components/content/errorPage/NotFound')
const noAccess = () => import('@/components/content/errorPage/NoAccess')

// media
const media = () => import('@/components/content/media/index.vue')
const tagSearch = () => import('@/components/content/media/TagSearch.vue')
const categoryDetail = () => import('@/components/content/media/categoryDetail.vue')
const channelDetail = () => import('@/components/content/media/channelDetail.vue')
const videoDetail = () => import('@/components/content/media/videoDetail.vue')

// global

const globalPage = () => import('@/components/content/globalPage/index.vue')
// webinar-client
const webinarClient = () => import('@/components/content/webinarClient/List.vue')
const webinarDetail = () => import('@/components/content/webinarClient/Detail.vue')

const homePage = () => import('@/components/content/homePage/index.vue')

// basf product client
const basfProductList = () => import('@/components/content/basfProductClient/index.vue')
const basfProductDetail = () => import('@/components/content/basfProductClient/detail.vue')

const dlitE3X = () => import('@/components/content/dlitE3X/index.vue')
const myComparison = () => import('@/components/content/myComparison/index.vue')
const myComments = () => import('@/components/content/myComments/index.vue')
const myFavorites = () => import('@/components/content/myFavorites/index.vue')
const myRequest = () => import('@/components/content/myRequest/index.vue')
const documentRequest = () => import('@/components/content/myRequest/children/documentRequest.vue')
const recentlyViewed = () => import('@/components/content/recentlyViewed/index.vue')
const brandComparison = () => import('@/components/content/myComparison/brand.vue')
const formulationComparison = () => import('@/components/content/myComparison/formulation.vue')
const productComparison = () => import('@/components/content/myComparison/product.vue')
const inciComparison = () => import('@/components/content/myComparison/inci.vue')
const newVideoManagement = () => import('@/components/content/newVideoManagement/index.vue')

Vue.use(Router)

const router = new Router({
  scrollBehavior (to, from, savedPosition) {
    setTimeout(() => {
      try {
        document.getElementById('basfContent').scrollTop = 0
      } catch (e) {}
    }, 0)
  },
  routes: [
    {
      // 忘记密码页面 ---> 白名单
      path: '/up-pa',
      name: 'Update Password',
      component: Forgot
    }, {
      // 容器
      path: '/',
      component: Index,
      redirect: '/homeoutside',
      children: [
        {
          // 主页面（登录页） ---> 白名单
          path: '/homeoutside',
          name: 'homeoutside',
          component: HomeOutside
        }, {
          path: '/register-result',
          name: 'registerResult',
          component: RegisterResult
        }, {
          // 系统主页面容器 ---> 白名单
          path: '/home',
          name: 'HOME',
          component: HomeInside,
          redirect: '/homeoutside',
          children: [
            {
              path: '/not-found',
              name: 'notFound',
              component: notFound
            },
            {
              path: '/no-access',
              name: 'noAccess',
              component: noAccess
            },
            {
              path: '/home-page',
              name: 'homePage',
              component: homePage
            },
            {
              path: '/dlite3x',
              name: 'dlitE3X',
              component: dlitE3X,
              children: [
                {
                  path: 'message-center',
                  name: 'messageCenter',
                  component: messageCenter
                },
                // {
                //   path: 'my-order',
                //   name: 'myOrder',
                //   component: MyOrder
                // },
                {
                  path: 'my-comparison',
                  name: 'myComparison',
                  component: myComparison,
                  children: [
                    {
                      path: 'brand-comparison',
                      name: 'brandComparison',
                      component: brandComparison
                    },
                    {
                      path: 'formulation-comparison',
                      name: 'formulationComparison',
                      component: formulationComparison
                    },
                    {
                      path: 'product-comparison',
                      name: 'productComparison',
                      component: productComparison
                    },
                    {
                      path: 'inci-comparison',
                      name: 'ingredientComparison',
                      component: inciComparison
                    }
                  ]
                },
                {
                  path: 'my-comments',
                  name: 'myComments',
                  component: myComments
                },
                {
                  path: 'my-favorites',
                  name: 'myFavorites',
                  component: myFavorites
                },
                {
                  path: 'my-request',
                  name: 'myRequest',
                  component: myRequest,
                  children: [
                    {
                      path: 'my-order',
                      name: 'myOrder',
                      component: MyOrder
                    },
                    {
                      path: 'document-request',
                      name: 'documentRequest',
                      component: documentRequest
                    }
                  ]
                },
                {
                  path: 'recently-viewed',
                  name: 'recentlyViewed',
                  component: recentlyViewed
                }
              ]
            },
            {
              path: '/my-profile',
              name: 'myProfile',
              component: MyProfile,
              meta: [{ path: null, name: 'breadCrumb.myProfile' }]
            }, {
              // MyOrder 详情页
              path: '/or-de/:orderId',
              name: 'orderDetail',
              component: OrderDetail,
              meta: [{ path: '/my-order', name: 'breadCrumb.myOrder' }, { path: null, name: 'breadCrumb.orderDetail' }]
            }, {
              // Consumer Insights 主页面
              path: '/co-in',
              name: 'consumerInsights',
              component: ConsumerInsights,
              meta: [{ path: null, name: 'breadCrumb.consumerInsights' }]
            },
            // {
            //   // Consumer Insights --- trend
            //   path: '/co-in/trend',
            //   name: 'trendIndex',
            //   component: TrendMain,
            //   meta: [{ path: null, name: 'breadCrumb.trend' }]
            // },
            {
              // Consumer Insights --- trend
              path: '/co-in/trend',
              name: 'trendIndex',
              component: TrendList,
              meta: []
            },
            {
              // Consumer Insights --- trend 筛选列表
              path: '/co-in/trend/list/:trendtype/:trendname',
              name: 'trendList',
              component: TrendMainChild,
              meta: [{ path: '/co-in/trend', name: 'breadCrumb.trend' }, { path: null, name: 'breadCrumb.trendList' }]
            }, {
              // Consumer Insights --- trend 详情
              path: '/co-in/trend/detail/:id',
              name: 'trendDetail',
              component: NewTrendDetail,
              meta: [{ path: '/co-in/trend', name: 'breadCrumb.trend' }]
            }, {
              // Consumer Insights --- market
              path: '/co-in/market',
              name: 'marketOverview',
              component: MarketOverview,
              meta: [{ path: null, name: 'breadCrumb.marketOverview' }]
            }, {
              // Consumer Insights --- market
              path: '/co-in/ranking',
              name: 'topRankingBevol',
              component: TopRankingClient,
              meta: []
            },
            // {
            //   // Consumer Insights --- ranking
            //   path: '/co-in/ranking',
            //   name: 'topRanking',
            //   component: TopRanking,
            //   redirect: '/co-in/ranking/bevol',
            //   meta: [{ path: null, name: 'breadCrumb.topRanking' }],
            //   children: [{
            //     // Consumer Insights --- ranking --- bevol
            //     path: '/co-in/ranking/bevol',
            //     name: 'topRankingBevol',
            //     component: Bevol,
            //     redirect: '/co-in/ranking/bevol/claims',
            //     meta: [{ path: null, name: 'breadCrumb.topRanking' }],
            //     children: [
            //       {
            //       // Consumer Insights --- ranking --- bevol --- For Products
            //         path: '/co-in/ranking/bevol/products',
            //         name: 'forProducts',
            //         component: ConsumerProductsInsights,
            //         meta: [{ path: null, name: 'breadCrumb.topRanking' }]
            //       }, {
            //         // Consumer Insights --- ranking --- bevol --- For Claims
            //         path: '/co-in/ranking/bevol/claims',
            //         name: 'forClaims',
            //         component: ConsumerClaimsInsights,
            //         meta: [{ path: null, name: 'breadCrumb.topRanking' }]
            //       }, {
            //         // Consumer Insights --- ranking --- bevol --- For Brand
            //         path: '/co-in/ranking/bevol/brand',
            //         name: 'forBrand',
            //         component: ConsumerBrandInsights,
            //         meta: [{ path: null, name: 'breadCrumb.topRanking' }]
            //       }
            //     ]
            //   }, {
            //     // Consumer Insights --- ranking --- Other Website
            //     path: '/co-in/ranking/other',
            //     name: 'topRankingOtherWebsite',
            //     component: OtherWebsite,
            //     meta: [{ path: null, name: 'breadCrumb.topRanking' }]
            //   }, {
            //     // Consumer Insights --- ranking --- Social Media
            //     path: '/co-in/ranking/social',
            //     name: 'topRankingSocialMedia',
            //     component: SocialMedia,
            //     meta: [{ path: null, name: 'breadCrumb.topRanking' }]
            //   }]
            // },
            {
              // brandAnalytics 主页面
              path: '/br-an',
              name: 'brandList',
              component: brandClient,
              meta: []
            }, {
              // brandAnalytics 详情页
              path: '/br-an/detail/:brandId',
              name: 'brandDetail',
              component: BrandDetail,
              meta: [{ path: '/br-an', name: 'breadCrumb.brand' }, { path: null, name: 'breadCrumb.brandDetail' }]
            }, {
              // ConsumerProducts 主页面
              path: '/co-pr',
              name: 'productList',
              component: ConsumerProductsList,
              meta: []
            }, {
              // ConsumerProducts 详情页
              path: '/co-pr/detail/:pId',
              name: 'productDetail',
              component: ConsumerProductDetail,
              meta: [{ path: '/co-pr', name: 'breadCrumb.consumerProducts' }, { path: null, name: 'breadCrumb.consumerProductsDetail' }]
            },
            // {
            //   // Concepts Collection 主页面
            //   path: '/co-co',
            //   name: 'conceptIndex',
            //   component: ConceptsCollection,
            //   meta: [{ path: null, name: 'breadCrumb.conceptsCollection' }]
            // },
            {
              // Concepts Collection 主页面
              path: '/co-co',
              name: 'conceptIndex',
              component: ConceptList,
              meta: []
            },
            {
              // Concepts Collection 详情页 容器
              path: '/co-co/no-co',
              name: 'newOldConcepts',
              component: NewOldConcepts,
              redirect: '/co-co/no-co/n-co',
              children: [{
                // tab页 New concepts list
                path: '/co-co/no-co/n-co',
                name: 'conceptList',
                component: NewConcepts,
                meta: [{ path: '/co-co', name: 'breadCrumb.conceptsCollection' }, { path: null, name: 'breadCrumb.newConceptsList' }]
              }, {
                // tab页 Old concepts list
                path: '/co-co/no-co/more',
                name: 'oldCconceptList',
                component: MoreConcepts,
                meta: [{ path: '/co-co', name: 'breadCrumb.conceptsCollection' }, { path: null, name: 'breadCrumb.oldConceptsList' }]
              }]
            },
            // {
            //   // Concept Detail
            //   path: '/co-co/euperlan',
            //   name: 'conceptDetail',
            //   component: Euperlan,
            //   meta: [{ path: '/co-co', name: 'breadCrumb.conceptsCollection' }, { path: null, name: 'breadCrumb.conceptDetail' }]
            // }, 
            {
              // Concept Detail
              path: '/co-co/euperlan',
              name: 'conceptDetail',
              component: ConceptDetail,
              meta: [{ path: '/co-co', name: 'breadCrumb.conceptsCollection' }]
            }, {
              // Formulation Design 主页面
              path: '/fo-de',
              name: 'formulationList',
              component: FormulationDesignIndex,
              meta: []
            }, {
              // Formulation Design 详情页面
              path: '/fo-de/detail',
              name: 'formulationDetail',
              component: FormulationDetail,
              meta: [{ path: '/fo-de', name: 'breadCrumb.formulationDesign' }, { path: null, name: 'breadCrumb.formulationDetail' }]
            }, {
              // basf product list
              path: '/basf-product-list',
              name: 'basfProductList',
              component: basfProductList,
              meta: []
            }, {
              // basf product detail
              path: '/basf-product-detail',
              name: 'basfProductDetail',
              component: basfProductDetail,
              meta: [{ path: '/basf-product-list', name: 'searchMenu.basfProduct' }]
            },
            // {
            //   // Ingredient Selection 主页面
            //   path: '/in-se',
            //   name: 'ingredientSelectList',
            //   component: IngredientSelection,
            //   meta: [{ path: null, name: 'breadCrumb.ingredientSelection' }]
            // }, 
            {
              // Ingredient Selection --- Ingredient Detail
              path: '/in-se',
              name: 'ingredientSelectList',
              component: IngredientList,
              meta: []
              // meta: [{ path: '/in-se', name: 'breadCrumb.ingredientSelection' }, { path: null, name: 'breadCrumb.ingredientDetail' }]
            },
            {
              // Ingredient Selection --- Ingredient Detail
              path: '/in-se/detail',
              name: 'ingredientSelectDetail',
              component: NewIngredientDetail,
              // meta: []
              meta: [{ path: '/in-se', name: 'breadCrumb.ingredientSelection' }, { path: null, name: 'breadCrumb.ingredientDetail' }]
            }, 
            // {
            //   // Ingredient Selection --- Ingredient Detail
            //   path: '/in-se/detail',
            //   name: 'ingredientSelectDetail',
            //   component: IngredientDetail,
            //   meta: [{ path: '/in-se', name: 'breadCrumb.ingredientSelection' }, { path: null, name: 'breadCrumb.ingredientDetail' }]
            // }, 
            // {
            //   // Ingredient Selection --- Trade Name Detail
            //   path: '/in-se/tr-na/detail',
            //   name: 'basfProductDetail',
            //   component: TradeNameDetail,
            //   meta: [{ path: '/in-se', name: 'breadCrumb.ingredientSelection' }, { path: null, name: 'breadCrumb.tradeNameDetail' }]
            // }, 
            {
              // boss 主页面
              path: '/boss',
              name: 'boss',
              component: Boss,
              meta: [{ path: null, name: 'breadCrumb.boss' }]
            }, {
              // boss AdvancedSearch页面
              path: '/boss/ad-se',
              name: 'advancedSearch',
              component: AdvancedSearch,
              meta: [{ path: '/boss', name: 'breadCrumb.boss' }, { path: null, name: 'breadCrumb.advancedSearch' }]
            }, {
              // boss search 页面
              path: '/boss/search',
              name: 'bossIndex',
              component: Search,
              meta: [{ path: '/boss', name: 'breadCrumb.boss' }, { path: null, name: 'breadCrumb.bossProduct' }]
            }, 
            // {
            //   // My Comparison 容器
            //   path: '/compar',
            //   name: 'comparsion',
            //   component: Comparsion,
            //   redirect: '/compar/br-an',
            //   children: [{
            //     // tab ---> Product
            //     path: '/compar/co-pr',
            //     name: 'productComparison',
            //     component: ProductComparison,
            //     meta: [{ path: '/co-pr', name: 'breadCrumb.consumerProducts' }, { path: null, name: 'breadCrumb.productComparison' }]
            //   }, {
            //     // tab ---> Brand
            //     path: '/compar/br-an',
            //     name: 'brandComparison',
            //     component: BrandComparison,
            //     meta: [{ path: '/br-an', name: 'breadCrumb.brand' }, { path: null, name: 'breadCrumb.brandComparison' }]
            //   }, {
            //     // tab ---> Formulation
            //     path: '/compar/fo-de',
            //     name: 'formulationComparison',
            //     component: FormulationComparison,
            //     meta: [{ path: '/fo-de', name: 'breadCrumb.formulationDesign' }, { path: null, name: 'breadCrumb.formulationComparison' }]
            //   }, {
            //     // tab ---> INCI
            //     path: '/compar/in-se',
            //     name: 'ingredientComparison',
            //     component: IngredientComparison,
            //     meta: [{ path: '/in-se', name: 'breadCrumb.ingredientSelection' }, { path: null, name: 'breadCrumb.ingredientComparison' }]
            //   }]
            // }, 
            {
              // Consumer Products详情 新配方提交表单1
              path: '/ne-de',
              name: 'formulationNewDesign',
              component: FormulationNewDesign,
              meta: [{ path: null, name: 'breadCrumb.formulationNewDesign' }]
            }, {
              // Consumer Products详情 新配方提交表单2
              path: '/purchase',
              name: 'formulationPurchase',
              component: FormulationPurchase,
              meta: [{ path: '/ne-de', name: 'breadCrumb.formulationNewDesign' }, { path: null, name: 'breadCrumb.purchase' }]
            }, {
              // Consumer Products详情 新配方提交表单3
              path: '/pu-pur',
              name: 'purchasePurchase',
              component: PurchasePurchase,
              meta: [{ path: '/ne-de', name: 'breadCrumb.formulationNewDesign' }, { path: null, name: 'breadCrumb.purchase' }]
            }, {
              // Consumer Products详情 新配方提交表单4
              path: '/pu-ok',
              name: 'purchase',
              component: Purchase,
              meta: [{ path: '/ne-de', name: 'breadCrumb.formulationNewDesign' }, { path: null, name: 'breadCrumb.purchase' }]
            }, {
              // Consumer Products详情 新配方提交表单5
              path: '/pu-di',
              name: 'purchaseDirectly',
              component: PurchaseDirectly,
              meta: [{ path: '/ne-de', name: 'breadCrumb.formulationNewDesign' }, { path: null, name: 'breadCrumb.purchase' }]
            }, {
              // Introduction Video 模块
              path: '/introVideo',
              name: 'introVideo',
              component: introVideo,
              redirect: '/introVideo/videoList',
              children: [{
                path: '/introVideo/videoList',
                name: 'introductionVideoList',
                component: videoList,
                meta: [{ path: '/introVideo', name: 'breadCrumb.introVideo' }]
              }, {
                path: '/introVideo/webinarList/:id',
                name: 'eLearningList',
                component: webinarList,
                meta: [{ path: '/introVideo', name: 'breadCrumb.introVideo' }]
              }, {
                path: '/introVideo/care/:id',
                name: 'eLearningDetail',
                component: care,
                meta: [{ path: '/introVideo', name: 'breadCrumb.introVideo' }, { path: null, name: 'breadCrumb.care' }]
              }]
            },
            {
              // basf product list
              path: '/event-list',
              name: 'eventList',
              component: eventClient,
              meta: []
            },
            {
              // basf product detail
              path: '/event-detail',
              name: 'eventDetail',
              component: eventDetail,
              meta: [{ path: '/event-list', name: 'searchMenu.event' }]
            },
            {
              path: '/event-formulation-list',
              name: 'eventFormulationList',
              component: eventFormulationList,
              meta: [{ path: '/event-list', name: 'searchMenu.event' }]
            },
            {
              path: '/event-basf-product-list',
              name: 'eventBasfProductList',
              component: eventBasfProductList,
              meta: [{ path: '/event-list', name: 'searchMenu.event' }]
            },
            // Data management
            {
              path: '/management/BASFProduct',
              name: 'BASFProductManagement',
              component: BASFProduct,
              meta: [{ path: '/management/BASFProduct', name: 'breadCrumb.BASFProduct' }],
              props: { isUpload: false }
            }, {
              path: '/management/formulation',
              name: 'formulationManagement',
              component: formulation,
              meta: [{ path: '/management/formulation', name: 'breadCrumb.formulation' }],
              props: { isUpload: false }
            }, {
              path: '/management/trend',
              name: 'trendManagement',
              component: trend,
              meta: [{ path: '/management/trend', name: 'breadCrumb.trendManagement' }],
              props: { isUpload: false }
            }, {
              path: '/management/concept',
              name: 'conceptManagement',
              component: concept,
              meta: [{ path: '/management/concept', name: 'breadCrumb.concept' }],
              props: { isUpload: false }
            }, {
              path: '/management/lifestyleSegment',
              name: 'lifestyleSegment',
              component: lifestyleSegment,
              meta: [{ path: '/management/lifestyleSegment', name: 'breadCrumb.keywordLibrary' }]
            }, {
              path: '/management/event',
              name: 'event',
              component: event,
              meta: [{ path: '/management/event', name: 'breadCrumb.event' }],
            }, {
              path: '/management/eventSpeaker',
              name: 'eventSpeaker',
              component: eventSpeaker,
              meta: [{ path: '/management/event', name: 'breadCrumb.event' },
              { path: '/management/event', name: 'breadCrumb.event' }, { path: '/management/eventSpeaker', name: 'breadCrumb.eventSpeaker' }],
            }, {
              path: '/management/eventFormulationCategory',
              name: 'eventFormulationCategory',
              component: eventFormulationCategory,
              meta: [{ path: '/management/event', name: 'breadCrumb.event' }, { path: '/management/event', name: 'breadCrumb.event' },
              { path: '/management/eventFormulationCategory', name: 'breadCrumb.eventFormulationCategory' }],
            }, {
              path: '/management/eventFormulation',
              name: 'eventFormulation',
              component: eventFormulation,
              meta: [{ path: '/management/event', name: 'breadCrumb.event' }, { path: '/management/event', name: 'breadCrumb.event' },
              { path: '/management/eventFormulation', name: 'breadCrumb.eventFormulation' }],
            }, {
              path: '/management/eventProductCategory',
              name: 'eventProductCategory',
              component: eventProductCategory,
              meta: [{ path: '/management/event', name: 'breadCrumb.event' }, { path: '/management/event', name: 'breadCrumb.event' },
              { path: '/management/eventProductCategory', name: 'breadCrumb.eventProductCategory' }],
            }, {
              path: '/management/eventConcept',
              name: 'eventConcept',
              component: eventConcept,
              meta: [{ path: '/management/event', name: 'breadCrumb.event' }, { path: '/management/event', name: 'breadCrumb.event' },
              { path: '/management/eventConcept', name: 'breadCrumb.eventConcept' }],
            }, {
              path: '/management/eventTrend',
              name: 'eventTrend',
              component: eventTrend,
              meta: [{ path: '/management/event', name: 'breadCrumb.event' }, { path: '/management/event', name: 'breadCrumb.event' },
              { path: '/management/eventTrend', name: 'breadCrumb.eventTrend' }],
            }, {
              path: '/management/eventProduct',
              name: 'eventProduct',
              component: eventProduct,
              meta: [{ path: '/management/event', name: 'breadCrumb.event' }, { path: '/management/event', name: 'breadCrumb.event' },
              { path: '/management/eventProduct', name: 'breadCrumb.eventProduct' }],
            },{
              path: '/management/webinar',
              name: 'webinar',
              component: webinar,
              meta: [{ path: '/management/webinar', name: 'breadCrumb.webinar' }]
            },{
              path: '/management/push',
              name: 'push',
              component: push,
              meta: [{ path: '/management/push', name: 'breadCrumb.push' }]
            },
            // {
            //   path: '/management/deeplink',
            //   name: 'deeplink',
            //   component: deeplink,
            //   meta: [{ path: '/management/deeplink', name: 'breadCrumb.deeplink' }]
            // },
            {
              path: '/management/topRankForOtherWebsite',
              name: 'topRankForOtherWebsite',
              component: topRankForOtherWebsite,
              meta: [{ path: '/management/topRankForOtherWebsite', name: 'breadCrumb.topManagement' }]
            },{
              path: '/management/topRrankingSourceIndex',
              name: 'topRrankingSourceIndex',
              component: topRrankingSourceIndex,
              meta: [{ path: '/management/topRankForOtherWebsite', name: 'breadCrumb.topManagement' }, { path: '/management/topRrankingSourceIndex', name: 'breadCrumb.topRrankingSourceIndexstatus' }]
            },{
              path: '/management/otherWebsiteEditProduct',
              name: 'otherWebsiteEditProduct',
              component: otherWebsiteEditProduct,
              meta: [{ path: '/management/topRankForOtherWebsite', name: 'breadCrumb.topManagement' }, { path: '/management/otherWebsiteEditProduct', name: 'breadCrumb.otherWebsiteEditProductStatus' }]
            },
            {
              path: '/management/message',
              name: 'message',
              component: message,
              meta: [{ path: '/management/message', name: 'breadCrumb.message' }]
            },
            {
              path: '/management/inciManagement',
              name: 'inciManagement',
              component: inciManagement,
              meta: [{ path: '/management/inciManagement', name: 'breadCrumb.inciManagement' }]
            },
            {
              path: '/management/video',
              name: 'newVideoManagement',
              component: newVideoManagement,
              meta: [{ path: '/management/video', name: 'breadCrumb.media' }]
            },
            // User Management
            {
              path: '/userManagement/userBehavior',
              name: 'userBehavior',
              component: userBehavior,
              meta: [{ path: '/userManagement/userBehavior', name: 'breadCrumb.userBehavior' }]
            }, {
              path: '/userManagement/accounts',
              name: 'accounts',
              component: accounts,
              meta: [{ path: '/userManagement/accounts', name: 'breadCrumb.accounts' }]
            }, {
              path: '/userManagement/role',
              name: 'role',
              component: role,
              meta: [{ path: '/userManagement/role', name: 'breadCrumb.role' }]
            },
            {
              path: '/userManagement/feedback',
              name: 'feedback',
              component: feedback,
              meta: [{ path: '/userManagement/feedback', name: 'breadCrumb.feedback' }]
            }, {
              path: '/userManagement/commentData',
              name: 'commentData',
              component: commentData,
              meta: [{ path: '/userManagement/commentData', name: 'breadCrumb.commentData' }]
            }, {
              path: '/userManagement/userGroup',
              name: 'userGroup',
              component: userGroup,
              meta: [{ path: '/userManagement/userGroup', name: 'breadCrumb.userGroup' }]
            }, {
              path: '/userManagement/activityLog',
              name: 'activityLog',
              component: activityLog,
              meta: [{ path: '/userManagement/activityLog', name: 'breadCrumb.activityLog' }]
            }, {
              path: '/userManagement/whiteList',
              name: 'whiteList',
              component: whiteList,
              meta: [{ path: '/userManagement/whiteList', name: 'breadCrumb.whiteList' }]
            }, {
              path: '/userManagement/blackList',
              name: 'blackList',
              component: blackList,
              meta: [{ path: '/userManagement/blackList', name: 'breadCrumb.blackList' }]
            }, {
              path: '/userManagement/orderList',
              name: 'orderList',
              component: requestList,
              meta: [{ path: '/userManagement/orderList', name: 'orderList.requestList' }]
            },
            // General Management
            {
              path: '/generalManagement/aboutBASF',
              name: 'aboutBASF',
              component: aboutBASF,
              meta: [{ path: '/generalManagement/aboutBASF', name: 'breadCrumb.aboutBASF' }]
            },
            {
              path: '/generalManagement/appPictures',
              name: 'appPictures',
              component: appPictures,
              meta: [{ path: '/generalManagement/appPictures', name: 'breadCrumb.appPictures' }]
            },
            {
              path: '/generalManagement/co-owner',
              name: 'coownerSetting',
              component: coowner,
              meta: [{ path: '/generalManagement/co-owner', name: 'breadCrumb.coownerSetting' }]
            },
            {
              path: '/generalManagement/qrCode',
              name: 'qrCode',
              component: qrCode,
              meta: [{ path: '/generalManagement/qrCode', name: 'breadCrumb.qrCode' }]
            },
            {
              path: '/generalManagement/announcement',
              name: 'announcement',
              component: announcement,
              meta: [{ path: '/generalManagement/announcement', name: 'breadCrumb.announcement' }]
            },
            // My Data Upload
            {
              path: '/dataUpload/BASFProduct',
              name: 'BASFProductUpload',
              component: BASFProduct,
              meta: [{ path: '/dataUpload/BASFProduct', name: 'breadCrumb.BASFProductUpload' }],
              props: { isUpload: true }
            }, {
              path: '/dataUpload/formulation',
              name: 'formulationUpload',
              component: formulation,
              meta: [{ path: '/dataUpload/formulation', name: 'breadCrumb.formulationUpload' }],
              props: { isUpload: true }
            }, {
              path: '/dataUpload/trend',
              name: 'trendUpload',
              component: trend,
              meta: [{ path: '/dataUpload/trend', name: 'breadCrumb.trendUpload' }],
              props: { isUpload: true }
            }, {
              path: '/dataUpload/concept',
              name: 'conceptUpload',
              component: concept,
              meta: [{ path: '/dataUpload/concept', name: 'breadCrumb.conceptUpload' }],
              props: { isUpload: true }
            }, {
              path: '/dataUpload/introVideo',
              name: 'videoManagement',
              component: videoManagement,
              meta: [{ path: '/dataUpload/introVideo', name: 'breadCrumb.introVideoList' }]
            }, {
              path: '/dataUpload/competitor',
              name: 'competitor',
              component: competitor,
              meta: [{ path: '/dataUpload/competitor', name: 'breadCrumb.competitor' }]
            }, {
              path: '/dataUpload/topRanking',
              name: 'topManagement',
              component: topManagement,
              redirect: '/dataUpload/topRanking/productList',
              meta: [{ path: '/dataUpload/topRanking', name: 'breadCrumb.topManagement' }],
              children: [{
                path: '/dataUpload/topRanking/productList',
                name: 'otherProductList',
                component: productList,
                meta: [{ path: '/dataUpload/topRanking', name: 'breadCrumb.topManagement' }]
              }, {
                path: '/dataUpload/topRanking/productDetail',
                name: 'otherProductDetail',
                component: productDetail,
                meta: [{ path: '/dataUpload/topRanking', name: 'breadCrumb.topManagement' }, { path: '/dataUpload/topRanking/productDetail', name: 'breadCrumb.productDetail' }]
              }, {
                path: '/dataUpload/topRanking/sourceDetail',
                name: 'sourceDetail',
                component: sourceDetail,
                meta: [{ path: '/dataUpload/topRanking', name: 'breadCrumb.topManagement' }, { path: '/dataUpload/topRanking/sourceDetail', name: 'breadCrumb.sourceDetail' }]
              }]
            }, {
              // Data Relationship
              path: '/dataRelationship/formuCategory',
              name: 'formuCategory',
              component: formuCategory,
              meta: [{ path: '/dataRelationship/formuCategory', name: 'breadCrumb.formuCategory' }]
            }, {
              path: '/dataRelationship/formuProduct',
              name: 'formuProduct',
              component: formuProduct,
              meta: [{ path: '/dataRelationship/formuProduct', name: 'breadCrumb.formuProduct' }]
            }, {
              path: '/dataRelationship/delivery',
              name: 'delivery',
              component: delivery,
              meta: [{ path: '/dataRelationship/delivery', name: 'breadCrumb.delivery' }]
            }, {
              path: '/dataRelationship/application',
              name: 'application',
              component: application,
              meta: [{ path: '/dataRelationship/application', name: 'breadCrumb.application' }]
            }, {
              path: '/dataRelationship/benefit',
              name: 'benefit',
              component: benefit,
              meta: [{ path: '/dataRelationship/benefit', name: 'breadCrumb.benefit' }]
            }, {
              path: '/dataRelationship/productGroup',
              name: 'productGroup',
              component: productGroup,
              meta: [{ path: '/dataRelationship/productGroup', name: 'breadCrumb.productGroup' }]
            }, {
              path: '/dataRelationship/inciBasfMark',
              name: 'inciBasfMark',
              component: inciBasfMark,
              meta: [{ path: '/dataRelationship/inciBasfMark', name: 'breadCrumb.inciBasfMark' }]
            }, {
              path: '/dataRelationship/claim',
              name: 'claim',
              component: claim,
              meta: [{ path: '/dataRelationship/claim', name: 'breadCrumb.claim' }]
            }, {
              path: '/dataRelationship/brandClaim',
              name: 'brandClaim',
              component: brandClaim,
              meta: [{ path: '/dataRelationship/brandClaim', name: 'breadCrumb.brandClaim' }]
            },
            {
              path: '/dataRelationship/dliteFunction',
              name: 'dliteFunction',
              component: dliteFunction,
              meta: [{ path: '/dataRelationship/dlitefunction', name: 'breadCrumb.dliteFunction' }]
            }, {
              path: '/dataRelationship/basfFunction',
              name: 'basfFunction',
              component: basfFunction,
              meta: [{ path: '/dataRelationship/basfFunction', name: 'breadCrumb.basfFunction' }]
            },{
              path: '/dataRelationship/bevolFunction',
              name: 'bevolFunction',
              component: bevolFunction,
              meta: [{ path: '/dataRelationship/bevolFunction', name: 'breadCrumb.bevolFunction' }]
            }, {
              path: '/dataRelationship/filterKeyword',
              name: 'commentKeywords',
              component: newCommentKeywords,
              meta: [{ path: '/dataRelationship/filterKeyword', name: 'breadCrumb.commentKeywords' }]
            }, {
              // 搜索模块
              path: '/general',
              name: 'comprehensiveSearch',
              component: GeneralList,
              meta: [{ path: null, name: 'breadCrumb.comprehensiveSearch' }]
            }, {
              // 视频模块
              path: '/media',
              name: 'media',
              component: media,
              meta: [{ path: null, name: 'breadCrumb.media' }],
              children: [
                {
                  path: 'categoryDetail',
                  name: 'categoryDetail',
                  component: categoryDetail,
                  meta: [{ path: null, name: 'breadCrumb.media' }]
                }, {
                  path: 'channelDetail',
                  name: 'channelDetail',
                  component: channelDetail,
                  meta: [{ path: null, name: 'breadCrumb.media' }]
                }
              ]
            }, {
              // globalPage
              path: '/global-page',
              name: 'globalPage',
              component: globalPage,
              meta: []
            }, {
              path: '/tagSearch',
              name: 'tagSearch',
              component: tagSearch,
              meta: [{ path: '/media', name: 'breadCrumb.media' }, { path: null, name: 'breadCrumb.tagSearch' }]
            }, {
              path: '/videoDetail',
              name: 'videoDetail',
              component: videoDetail,
              meta: [{ path: '/media', name: 'breadCrumb.media' }, { path: null, name: 'txt.videoDetail' }]
            }, {
              path: '/webinar',
              name: 'webinarClient',
              component: webinarClient,
              meta: [{ path: null, name: 'breadCrumb.webinar' }]
            }, {
              path: '/webinar/detail',
              name: 'webinarDetail',
              component: webinarDetail,
              meta: [{ path: '/webinar', name: 'breadCrumb.webinar' }, { path: null, name: 'webinar.detail' }]
            }
          ]
        }
      ]
    }, {
      path: '*',
      redirect: '/homeoutside'
    }
  ]
})

// 埋点，获取上一页和当前页信息
router.beforeEach((to, from, next) => {
  window.visit_time = new Date().getTime();
  const backendRouter = [{
    path: '/userManagement',
    trackName: 'user_management'
  }, {
    path: '/dataUpload',
    trackName: 'data_upload'
  }, {
    path: '/management',
    trackName: 'management'
  }, {
    path: '/dataRelationship',
    trackName: 'data_relationship'
  }, {
    path: '/generalManagement',
    trackName: 'general_management'
  }]
  const toItem = backendRouter.find(v => to.path.includes(v.path))
  const fromItem = backendRouter.find(v => from.path.includes(v.path))
  Track.getPreviousObj({
    from,
    name: fromItem ? fromItem.trackName : from.name
  });
  Track.getCurrentObj({
    to,
    name: toItem ? toItem.trackName : to.name
  });
  next();
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js